import React, { Component } from "react"
import moment from "moment"
import ReportCard from "app/components/normal/pgd/ReportCard"
import { observer, inject } from "mobx-react"

@inject("store") @observer
export default class extends Component {
  componentDidMount() {
    const { list: { getTableData, updateTableData, updateQueryMap } } = this.props.store.report
    let start = moment(moment() - 3 * 1000 * 3600 * 24).format("YYYY-MM-DD")

    updateQueryMap({ limit: null, start: start })
    getTableData()
      .then(
        res => {
          updateTableData(res)
        }
      )
  }

  render() {
    let { report: { list: { tableData } }, report } = this.props.store

    return (
      <div>
        {tableData.slice().length !== 0 ?
          <h2 className="sub-title">最新报告</h2> : <h2 className="sub-title-disable">今日尚无最新报告</h2>}
        {tableData.slice().map((item, index) => {
          return <ReportCard store={report} index={index} key={index} data={item} />
        })}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/pgd/dashboard/containers/DataTable.js